import { render } from "./MFITTSeatWindow.vue?vue&type=template&id=8d20581a&scoped=true"
import script from "./MFITTSeatWindow.vue?vue&type=script&lang=js"
export * from "./MFITTSeatWindow.vue?vue&type=script&lang=js"

import "./MFITTSeatWindow.vue?vue&type=style&index=0&id=8d20581a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8d20581a"

export default script